import React, { useEffect, useRef, useState, useCallback } from 'react';
import { useDaily, useLocalSessionId } from '@daily-co/daily-react';
import { pageAtom, isAuthAtom, myNftBackAtom, BGMAtom, BGMVolumeAtom } from '../../State';
import { useNavigate, useParams } from 'react-router-dom';
import { useRecoilState, useSetRecoilState } from 'recoil';
import { ReactComponent as BackAddSVG } from '../Images/buttons/backAddButton.svg';
import { ReactComponent as VolumeSVG } from '../Images/buttons/volumeIcon.svg';
import { ReactComponent as StartSVG } from '../Images/buttons/musicStartButton.svg';
import { ReactComponent as StopSVG } from '../Images/buttons/musicStopButton.svg';
import { ReactComponent as AddSVG } from '../Images/buttons/musicAdd.svg';
import KUTE from 'kute.js';
import './NFT.css';
import 'react-loading-skeleton/dist/skeleton.css';
import NFTItem from './NFTItem';
import { useTranslation } from 'react-i18next';
import { storage } from '../Util/Firebase';
import { ref, uploadBytesResumable, getDownloadURL } from 'firebase/storage';
import { ReactComponent as UploadingSVG } from '../Images/buttons/uploadingButton.svg';
import { getImagePath } from '../Util/utils';
import { isMobile } from 'react-device-detect';
import isElectron from '../../Global';
import DataModel from '../Util/DataModel';
import Slider from '@mui/material/Slider';
import NFTBGMItem from './NFTBGMItem';

export default function NFTBGM({ setNftType }) {
  const callObject = useDaily();
  const localSessionId = useLocalSessionId();

  //Recoil系
  const [myNftBackState, setNftBackState] = useRecoilState(myNftBackAtom);
  const [pageState, setPageState] = useRecoilState(pageAtom);
  const [isAuthState, setAuthState] = useRecoilState(isAuthAtom);
  const [BGMState, setBGMState] = useRecoilState(BGMAtom);
  const [BGMVolumeState, setBGMVolumeState] = useRecoilState(BGMVolumeAtom);
  const { t } = useTranslation();

  //その他
  const inputFileRef = useRef(null);
  const [uploadingState, setUploadingState] = useState(false);
  const [myCustomBGM, setMyCustomBGM] = useState(null);
  const [tempVolumeState, setTempVolumeState] = useState(30);

  //初期化
  useEffect(() => {
    //データ取得
    getData();
  }, []);

  useEffect(() => {
    // setTempVolumeState(BGMVolumeState);
  }, [BGMVolumeState]);

  async function getData() {
    const result = await DataModel.getMyCustomBackground('BGM');

    if (result != null) {
      if (result.patternID != null) {
        setMyCustomBGM(result.patternID);
      }
    } else {
      setMyCustomBGM(null);
    }
  }

  //再生停止
  const stopBGM = async (e, newValue) => {
    setBGMState(null);

    saveData('stop');
  };

  //ボリューミュチェンジ
  const handleVolumeChange = async (e, newValue) => {
    setTempVolumeState(newValue);
  };

  //ボリュームチェンジ完了
  const handleVolumeComplete = async (e, newValue) => {
    setBGMVolumeState(tempVolumeState);
    //セッションに保存
    saveData(null, tempVolumeState);
  };

  //写真選択
  const selectPic = async (e) => {
    if (isAuthState == false) {
      alert('You need login');
      return;
    }

    const { files } = e.target;
    let file = files[0];

    //ファイルサイズチェック
    if (file.size > 10000000) {
      alert('File size should be less than 10MB');
      return;
    }

    //タイプチェック
    if (file.type == 'audio/mpeg' || file.type == 'audio/wav') {
    } else {
      alert('Only mp3 or wav format are accepted');
      return;
    }

    //ステータス変更
    setUploadingState(true);

    //UUID取得
    let uuid;
    try {
      let uuidResult = await DataModel.getUUID();
      if (uuidResult != null) {
        uuid = uuidResult.uuid;
      }
    } catch (e) {
      console.log(e);
    }

    //名前の変更
    let name = 'custom' + uuid + '.' + file.name.split('.').pop();

    const storageRef = ref(storage, `/mybgm/${name}`);

    const uploadTask = uploadBytesResumable(storageRef, file);
    uploadTask.on(
      'state_changed',
      (snapshot) => {
        const percent = Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100); // update progress
        console.log(percent);
      },
      (err) => setUploadingState(false),
      async () => {
        //        setNftBackState(name);

        //データベースに保存
        let result = await DataModel.saveCustomBackground(name, 'BGM');

        if (result != null) {
          setMyCustomBGM(name);
        }

        //ステータス変更
        setUploadingState(false);
      },
    );
  };

  //データベースに保存
  function saveData(status, newVolume) {
    if (BGMState == null) return;

    if (callObject != null) {
      //データベースに保存
      callObject
        .getMeetingSession()
        .then(async (session) => {
          try {
            //自分の情報をseessionに登録
            await DataModel.saveSessionToRoom(
              null, //ルームID
              session.meetingSession.id, //ルームのセッションID
              localSessionId, //ユーザーのテンポラリーユーザーID
              null, //顔
              null, //背景
              null, //顔認識 <isFaceTrackingå>
              null, //録画中
              null, //ミュート
              null, //WhoUse
              null, //ユーザー他タイプ
              status ?? null, //BGM
              newVolume ?? null, //BGMボリューム
            );

            console.log('セッション保存完了');
          } catch (error) {
            console.log(error);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }

  //背景リストの表
  return (
    <>
      {/* <div className="renew">
        <div className="myNFTAvatarWrapWrap">
          <div className="myNFTAvatarWrap " onClick={() => setNftType('background')}>
            {t('nft.Image')}
          </div>
          <div className="myNFTAvatarWrap selected" onClick={() => setNftType('BGM')}>
            {t('nft.Music')}
          </div>
        </div>
      </div> */}

      <div className="bgmControlWrap">
        <div className="bgmControlIcon">
          {BGMState == null ? <StartSVG /> : <StopSVG onClick={stopBGM} />}
        </div>
        {BGMState == null ? (
          <div className="bgmControlText">{t('nft.No music is selected')}</div>
        ) : (
          <div className="bgmControlText selected">{t('nft.Playing')}</div>
        )}

        <div className="bgmControlVolume">
          <VolumeSVG />
          <Slider
            aria-label="Volume"
            value={tempVolumeState}
            size="small"
            onChange={handleVolumeChange}
            onChangeCommitted={handleVolumeComplete}
            style={{ color: '#000' }}
          />
        </div>
      </div>
      {/*背景一覧 */}
      <div className="nftListTitle4">{t('nft.Custom music')}</div>
      <div className="nftListBody">{t('nft.Use your audio (MP3 or WAV) for background music')}</div>
      <div className="renew">
        <div className="nftPartnerList">
          {uploadingState == false ? (
            <div className="nftPartnerItem addButton">
              <div className="relativeBox">
                <AddSVG onClick={() => inputFileRef.current?.click()} />
                <input
                  ref={inputFileRef}
                  type="file"
                  accept="audio/mpeg, audio/wav"
                  style={{ display: 'none' }}
                  onChange={selectPic}
                />
              </div>
            </div>
          ) : (
            <div
              className="myBackgroundWrap"
              style={{
                width: '25%',
                border: 'none',
                backgroundColor: '#fff',
                height: '70px',
                marginBottom: '20px',
              }}>
              <div id="myBackgroundWrapInside">
                <UploadingSVG />
              </div>
              <div className="myBackgroundText" style={{ bottom: '0px' }}>
                {t('nft.Uploading...')}
              </div>
            </div>
          )}
          {myCustomBGM != null && <NFTBGMItem imageURL={myCustomBGM} />}
        </div>
      </div>

      <div className="nftListTitle4">Jazz</div>
      <div className="renew">
        <div className="nftPartnerList">
          <NFTBGMItem imageURL={'bgm1.mp3'} />
          <NFTBGMItem imageURL={'bgm2.mp3'} />
        </div>
      </div>
    </>
  );
}
